import * as React from 'react';
import { useState } from 'react';
import { limitLength } from '../../common/stringUtils';
import { NoteService } from '../../services/noteService';
import { noteTextToReact } from '../../modules/helpers/noteTextFormatter';

export default function Note({ note }) {
    const [isFavorite, setIsFavorite] = useState(true);

    const title = note.title ? note.title : 'Markering';
    const noteText = note.text ?? null;

    const noteService = new NoteService();
    const noteId = note.id;

    const unPinFavorite = () => {
        noteService.unPinNote(
            noteId,
            () => {
                setIsFavorite(false);
            },
            () => { }
        );
    };

    return (
        <div className={`hero-menucontent__list-item ${isFavorite ? '' : 'hidden'}`}>

            <a href="" className="hero-menucontent__list-action-link hero-menucontent__list-action-link-move" onClick={(e) => { e.preventDefault(); }} title="Dra och släpp för att ändra ordning på genvägarna" tabIndex="-1"></a>

            <a href={`${note.pageUrl}#${note.markupId || ''}`} className="hero-menucontent__list-item-link">
                <div className={`top`}>
                    <div>
                        <div className="tag">
                            {note.pageHeading}
                        </div>
                    </div>
                    <button className={`hero-menucontent__list-action-toggle`}
                        onClick={(e) => {
                            e.preventDefault();
                            unPinFavorite();
                        }}>
                        Ta bort nål
                    </button>
                </div>
                <div className="bottom">
                    <div className={`notifications__link-item`}>
                        <span className="notification__header-title">{limitLength(title, 50)}</span> <span className="notification__header-text">{noteText ? noteTextToReact(noteText) : null}</span>
                    </div>
                </div>
            </a>
        </div>
    )
}
 